export const API_VERSION = 13;
export const STORY_VIEW_WIDTH = 805;